import React from 'react';
import { TacticalLabel } from './TacticalLabel';
import { Calculator, DollarSign, Gauge, ShieldCheck } from 'lucide-react';
const standards = [{
  icon: Calculator,
  title: 'MANUAL J SIZED',
  desc: 'Every system we install is properly load-calculated for your specific home. No guesswork.'
}, {
  icon: DollarSign,
  title: 'WE BEAT ANY ESTIMATE',
  desc: "Bring us your written estimate. We'll match it or beat it."
}, {
  icon: Gauge,
  title: 'PRESSURE TESTED & VERIFIED',
  desc: 'Every line set is nitrogen pressure tested before refrigerant ever sees the system.'
}, {
  icon: ShieldCheck,
  title: '10-YEAR PARTS & LABOR',
  desc: 'Industry-leading warranty backed by Sapper. We stand behind every install.'
}];
export function SapperStandard() {
  return <section className="py-24 bg-[#141A15]" data-id="element-294">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-295">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-296">
          {/* Left: Image */}
          <div className="relative aspect-[4/5] w-full max-w-md mx-auto lg:max-w-none" data-id="element-297">
            <div className="absolute inset-0 bg-sapper-olive/20 translate-x-4 translate-y-4 border border-sapper-olive/50" data-id="element-298" />
            <img src="https://cdn.magicpatterns.com/uploads/kGYKAaDFFy4gTAyTBrnT27/sapper-fan-motor.png" alt="Sapper technician performing fan motor repair on AC condenser" className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-299" />
            {/* Corner Accents */}
            <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-sapper-red" data-id="element-300" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-sapper-red" data-id="element-301" />
          </div>

          {/* Right: Content */}
          <div className="relative" data-id="element-302">
            {/* Tactical Bracket Frame */}
            <div className="absolute -inset-y-8 -left-8 w-4 border-y border-l border-sapper-red/30 hidden lg:block" data-id="element-303" />
            <div className="absolute -inset-y-8 -right-8 w-4 border-y border-r border-sapper-red/30 hidden lg:block" data-id="element-304" />

            <TacticalLabel className="mb-4" data-id="element-305">
              SECTION 03 // STANDARD OPERATING PROCEDURE
            </TacticalLabel>
            <h2 className="font-condensed font-bold text-5xl sm:text-6xl text-sapper-white uppercase tracking-tight mb-6" data-id="element-306">
              THE SAPPER STANDARD
            </h2>
            <p className="font-sans text-lg text-sapper-gray mb-12" data-id="element-307">
              Sappers in the Army are the engineers who build, breach, and clear
              the way under fire. We bring that same standard to every install.
            </p>

            <div className="space-y-8" data-id="element-308">
              {standards.map((std, idx) => <div key={idx} className="flex gap-6" data-id="element-309">
                  <div className="flex-shrink-0 mt-1" data-id="element-310">
                    <std.icon className="w-8 h-8 text-sapper-red" strokeWidth={1.5} data-id="element-311" />
                  </div>
                  <div data-id="element-312">
                    <h4 className="font-condensed font-bold text-xl text-sapper-white uppercase tracking-wide mb-1" data-id="element-313">
                      {std.title}
                    </h4>
                    <p className="font-sans text-sapper-gray text-sm leading-relaxed" data-id="element-314">
                      {std.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}